import axios from "axios";
import { API_BASE_URL } from "./BaseURL";


export const bookingService = {
  createBook: async (data) => {
    console.log(data)
    try {
      const res = await axios.post(`${API_BASE_URL}/book`, data);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getAllBook: async (params = {}) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book`, { params });
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  
  getById: async (id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book/${id}`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  deleteById: async (id) => {
    try {
      const res = await axios.delete(`${API_BASE_URL}/book/${id}`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  deleteAll: async (confirm = false) => {
    try {
      const res = await axios.delete(`${API_BASE_URL}/book`, {
        data: { confirm: confirm ? 'yes' : 'no' }
      });
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  
  markAsRead: async (id) => {
    try {
      const res = await axios.put(`${API_BASE_URL}/book/${id}/read`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  
  getNewBookingsCount: async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book/stats/new-counts`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  checkHallAvailability: async (date) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book/availability/${date}`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getBookingsByDate: async (date) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book/date/${date}`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getBookedDates: async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book/booked-dates`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getBookingStats: async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/book/stats`);
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  updateBookingStatus: async (id, status) => {
    try {
      const res = await axios.put(`${API_BASE_URL}/book/${id}/status`, { status });
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  bulkUpdateStatus: async (ids, status) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/book/bulk/status`, { 
        ids, 
        status 
      });
      return res.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};


axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
     
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default bookingService;